import { ToastrService } from 'ngx-toastr';
import { isPlatformBrowser } from '@angular/common';
import { catchError, of, Subject, switchMap, takeUntil } from 'rxjs';
import { Component, ChangeDetectorRef, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';

import { CatalogueCategoryType } from '@sifca-monorepo/ecommerce-generator';
import { InternalProductWithFavoriteStatusType } from '@sifca-monorepo/ecommerce-generator';

import { AppService, AuthService, SharedService } from '../../services';
import { OrdersService } from '../../services/order/order/order.service';

@Component({
  template: '',
})
export class BaseIndexCategoriesComponent implements AfterViewInit {
  protected unsubscribeAll: Subject<any> = new Subject<any>();

  isLoading = true;
  posId: string = '';
  isOutOfStock = true;
  authenticated: boolean;
  isButtonDisabled = false;
  catalogueCategories: CatalogueCategoryType[];
  products: InternalProductWithFavoriteStatusType[];

  constructor(
    protected appService: AppService,
    protected authService: AuthService,
    protected orderService: OrdersService,
    protected toastrService: ToastrService,
    protected sharedService: SharedService,
    protected changeDetectorRef: ChangeDetectorRef,
    @Inject(PLATFORM_ID) protected platformId: Object,
  ) {
    this.sharedService.posId$.subscribe((posId) => {
      this.posId = posId;
    });
    this.authService.authenticated$.subscribe((authenticated: boolean) => {
      this.authenticated = authenticated;
      this.changeDetectorRef.markForCheck();
    });
    this.appService.productsByUrlKey$.pipe(takeUntil(this.unsubscribeAll)).subscribe((products: InternalProductWithFavoriteStatusType[]) => {
      this.products = products;
      this.isLoading = true;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      window.dispatchEvent(new Event('resize'));
    }
    this.appService
      .getCatalogueCategoriesByTargetWithChildren()
      .pipe(
        switchMap((res: any) => {
          this.catalogueCategories = res;
          return this.appService.getSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatus(this.catalogueCategories[0]?.seo.urlKey);
        }),
      )
      .subscribe(()=> {
        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
      });
  }

  addToCart(product: InternalProductWithFavoriteStatusType) {
    this.isButtonDisabled = true;
    this.appService
      .getStockByTargetAndBarcode(product.barcodes[0].id)
      .pipe(
        catchError(() => {
          this.isOutOfStock = true;
          this.toastrService.error('Le produit est en rupture de stock !');
          return of(null);
        }),
      )
      .subscribe((res) => {
        if (res) {
          this.isOutOfStock = res.outOfStock;
          if (this.isOutOfStock === true) {
            this.toastrService.error('Le produit est en rupture de stock !');
          } else {
            if (!this.authenticated) {
              if (this.appService.itemInCart(product.barcodes[0])) {
                const value: any = {
                  barcode: product.barcodes[0],
                  price: {
                    unitGross: product.barcodes[0].price,
                    gross: product.barcodes[0].price,
                  },
                  product,
                  quantity: 1,
                };
                this.appService.updateLocalCart(value);
              } else {
                const value: any = {
                  barcode: product.barcodes[0],
                  price: {
                    unitGross: product.barcodes[0].price,
                    gross: product.barcodes[0].price,
                  },
                  product,
                  quantity: 1,
                };
                this.appService.addToLocalCart(value);
              }
              this.toastrService.success('Produit ajouté au panier.');
              this.isButtonDisabled = false;
            } else {
              const formValue = {
                barcode: product.barcodes[0].id,
                quantity: 1,
              };
              this.orderService
                .addProductsToCart([formValue])
                .pipe(
                  catchError(() => {
                    return of(null);
                  }),
                )
                .subscribe((res) => {
                  if (res) {
                    this.toastrService.success('Produit ajouté au panier.');
                    this.isButtonDisabled = false;
                  }
                });
              this.appService.loadCart();
            }
          }
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  getProducts(category: CatalogueCategoryType) {
    this.isLoading = true;
    this.changeDetectorRef.markForCheck();
    this.appService
      .getSimpleProductsByTargetAndCatalogueCategoryUrlKeyWithFavoriteStatus(category?.seo.urlKey)
      .pipe(
        catchError(() => {
          return of(null);
        }),
      )
      .subscribe((res: any) => {
        this.products = res.objects;
        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
      });
  }
}
